const SUCCESS_RANGE = {from: 200, to: 300};

const CLIENT_ERROR_RANGE = {from: 400, to: 500};

export const FORBIDDEN = 403;

export const NOT_FOUND = 404;

export const CONFLICT = 409;

export function responseOf(result) {
    return (result && result.response) || result || null;
}

export function statusOf(result) {
    const response = responseOf(result);

    return response && typeof response.status === 'number' ? response.status : 0;
}

export function wasSuccessful(status) {
    return status >= SUCCESS_RANGE.from && status < SUCCESS_RANGE.to;
}

export function wasDefinitelyRefused(status) {
    return status >= CLIENT_ERROR_RANGE.from && status < CLIENT_ERROR_RANGE.to;
}

function spelledOut(value) {
    return typeof value === 'string' && value.trim() ? value : null;
}

function firstErrorOfAnyField(fieldErrors) {
    const reported = Object.keys(fieldErrors)
        .map(name => fieldErrors[name])
        .find(errors => Array.isArray(errors) && errors.length);

    return reported ? reported[0] : null;
}

export function describeApiOutcome(result, {fallback, field} = {}) {
    const response = responseOf(result);
    const status = statusOf(result);

    if (wasSuccessful(status)) {
        return {ok: true, status, fieldError: null, message: null, data: response && response.data};
    }

    const data = (response && response.data) || {};
    const fieldErrors = data.errors && typeof data.errors === 'object' ? data.errors : {};
    const reported = field && Array.isArray(fieldErrors[field]) ? fieldErrors[field][0] : null;

    return {
        ok: false,
        status,
        fieldError: reported,
        message: reported
            || spelledOut(data.message)
            || firstErrorOfAnyField(fieldErrors)
            || fallback
            || null,
        data: null,
    };
}
